angular.module('myApp')

  .controller('ReportController', function ($scope, $state, $stateParams, $q,

    uuiData, Codifiers,
    StateSaver

  ) {

    const ctl = this

    $scope.kla = Codifiers.kla

    $scope.params = {
      q: '',
      pieteikumu_karta_id: undefined,
      jomas: {},
      mp_statusi: {},
      cfla_statusi: {},
      iesniedzejs_id: undefined,

      datums_no: undefined,
      datums_lidz: undefined,

      starpdisciplinars: 'all',

      flt_izskatisana: true,
      flt_izskatits: true,
      flt_iensniegts: true,
      flt_lzp_ok: true,
      flt_samaksats: true,
      flt_neaktuals: false,

      xls_mode: false,
    }

    const stored_filters = StateSaver.get('reports-all')
    if (stored_filters) {
      $scope.params = stored_filters
    }
    

    $scope.kartas = [
      { id: 5, nosaukums: '1.1.1.9, 1. kārta' },
      { id: 1, nosaukums: '1.1.1.2, 1. kārta' },
      { id: 2, nosaukums: '1.1.1.2, 2. kārta' },
      { id: 3, nosaukums: '1.1.1.2, 3. kārta' },
      { id: 4, nosaukums: '1.1.1.2, 4. kārta' },
    ]

    const reports = {
      'app.reports.a10': {
        title: 'Plānotie sasniedzamie iznākuma rādītāji',
        view: 'rep_iznakuma_raditaji',
        name: 'rep_iznakuma_raditaji',
        use_mp: false,
      },
      'app.reports.a20': {
        title: 'Sasniegtie projekta uzraudzības rādītāji',
        view: 'rep_uzraudzibas_raditaji',
        name: 'rep_uzraudzibas_raditaji',
        use_mp: true,
      },
      'app.reports.a30': {
        title: 'Finansējums',
        view: 'rep_finansejums',
        name: 'rep_finansejums',
        use_mp: true,
      },
      'app.reports.mp_finansejums': {
        title: 'MP Finansējums',
        view: 'rep_mp_finansejums',
        name: 'rep_mp_finansejums',
        use_mp: true,
      },
    } 

    $scope.report = reports[ $state.current.name ]

    $scope.statusi = [
      { id: 'IESNIEGTS', name: 'Iesniegts' },
      { id: 'IZSKATISANA', name: 'LZP izskatīšanā' },
      { id: 'IZSKATITS', name: 'Izskatīts' },
      { id: 'LZP_OK', name: 'LZP apstiprināts' },
      { id: 'SAMAKSATS', name: 'Samaksāts' },
    ]

    $scope.cfla_statusi = Codifiers.kla.cfla_statuss


    ctl.getReport = () => {

      StateSaver.put('reports-all', $scope.params)
      const params = []
      const params_remap = []
      Object.keys($scope.params).forEach( (k) => {
        let v = $scope.params[k]
        if ( ! v ) return
        if (k === 'jomas' || k === 'mp_statusi' || k === 'cfla_statusi') {
          v = Object.keys(v).filter(n => v[n]).join(',')
          if ( ! v.length ) return
        }
        params_remap[k] = v
        params.push(`${k}=${encodeURIComponent(v)}`)
      })

      if ($scope.params.xls_mode) {
        hackishDownload(`/download/report/${$scope.report.view}.xlsx?${params.join('&')}`, $scope.report.view + '.xlsx')
        // window.location = `/download/report/${$scope.report.view}.xlsx?${params.join('&')}`
        return
      }

      $scope.loading = true
      $scope.ready = false
      $scope.data = uuiData.list($scope.report.view, params_remap)
      $scope.data.$promise.then( () => {
        $scope.loading = false
        $scope.ready = true
      } ).catch($scope.failing)
    }
  })


const hackishDownload = (url, name) => {
  const a = document.createElement('a')
  a.download = name
  a.href = url
  a.target = '_blank'
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}
